import { tx, normalizeLocale } from '@transifex/native';
import { getTMSFormat } from '@raisin/cp-utils';
import { initTransifexWithFallback } from '@raisin/translations-backup';
const TRANSLATIONS_TTL_SEC = 10 * 60;

/**
 * Used by SSR to pass translation to browser
 */
export async function getServerSideTranslations({ locale, locales }) {
  initTransifexWithFallback({
    token: process.env.NEXT_PUBLIC_TRANSIFEX_NATIVE_TOKEN,
    filterTags: 'customerPortal',
  });

  const txLocale = normalizeLocale(getTMSFormat(locale));

  await tx.fetchTranslations(txLocale);

  tx._autorefresh = tx._autorefresh || {};
  if (!tx._autorefresh[txLocale]) {
    tx._autorefresh[txLocale] = Date.now();
  }

  if (Date.now() - tx._autorefresh[txLocale] > TRANSLATIONS_TTL_SEC * 1000) {
    tx._autorefresh[txLocale] = Date.now();
    tx.fetchTranslations(txLocale, { refresh: true });
  }

  return {
    locale: getTMSFormat(locale),
    locales,
    translations: tx.cache.getTranslations(txLocale),
  };
}

/**
 * Initialize client-side Transifex Native instance cache
 */
export function setClientSideTranslations({ locale, translations }) {
  if (!locale || !translations) return;
  tx.init({
    currentLocale: locale,
  });
  tx.cache.update(locale, translations);
}
